export default __webpack_public_path__ + "static/media/star.301fba74.webp";